var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50083 18.7871V18.5681C3.53295 17.9202 3.7406 17.2925 4.10236 16.7496C4.7045 16.0975 5.1167 15.2983 5.29571 14.436C5.29571 13.7695 5.29571 13.0935 5.35393 12.427C5.65469 9.21842 8.82728 7 11.9611 7H12.0387C15.1725 7 18.345 9.21842 18.6555 12.427C18.7137 13.0935 18.6555 13.7695 18.704 14.436C18.8854 15.3003 19.2972 16.1019 19.8974 16.7591C20.2618 17.2972 20.4698 17.9227 20.4989 18.5681V18.7776C20.5206 19.648 20.2208 20.4968 19.6548 21.1674C18.907 21.9515 17.8921 22.4393 16.8024 22.5384C13.607 22.8812 10.383 22.8812 7.18762 22.5384C6.09914 22.435 5.08576 21.9479 4.33521 21.1674C3.778 20.4963 3.48224 19.6526 3.50083 18.7871Z",
    stroke: "#040404",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55469 25.8518C10.054 26.4785 10.7871 26.884 11.592 26.9788C12.3968 27.0735 13.2069 26.8495 13.843 26.3564C14.0387 26.2106 14.2147 26.041 14.3669 25.8518",
    stroke: "#040404",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.570e07bf86b3b76929354feb3959bc9b.svg";
export { ForwardRef as ReactComponent };